const whKeyIndicator = {
  dc: 'DC',
  assessMonth: '考核月份',
  assessMonthStart: '开始月份',
  assessMonthEnd: '结束月份',
  carrierCode: '承运商代码',
  serviceProvider: '服务商',
  totalShipOrders: '收发货总单数',
  damagedBoxCount: '破损箱数',
  totalInventoryBox: '库存总箱数',
  spotCheckDiffBox: '子抽盘差异箱数',
  totalInOrders: '入库总单数',
  delayedInOrders: '入库延误单数',
  repackOrders: '重包装单数',
  repackErrorOrders: '重包装错误单数',
  totalShipErrorOrders: '收发错误总单数',
  spotCheckTotalBox: '抽盘总箱数',
  delayedComplaints: '入库延误投诉',
  adjustItems: '调整品项',
  createTime: '创建时间',
  msg: {}
};
export default whKeyIndicator;



// WEBPACK FOOTER //
// ./src/page/assess/whKeyIndicator/lang/whKeyIndicator.zh.js